import { CrossBranchSharing } from './cross-branch-sharing.model';

export class OrganisationConfig {
    canOrderSamplingSupplies = true;
    canOrderLabTests = true;
    crossBranchSharing: CrossBranchSharing | null = null;
    effectiveCrossBranchSharing: CrossBranchSharing = CrossBranchSharing.Enabled;
}
